import { useState } from 'react';
import { Box, Button, TextField, Typography, InputAdornment, Paper } from '@mui/material';
import { MailOutline } from '@mui/icons-material';
import { Link, useSearchParams } from 'react-router-dom';
import { forgotPassword } from '../services/forgotPassword';
// import echobuddyLogo from "../../assets/echobuddy.png";

function ConsultForgotPassword() {
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [searchParams] = useSearchParams();

  


const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) return;

    const appUrl = window.location.origin;

    try {
        const response = await forgotPassword({
            email,
            app_url: appUrl,
        });

        if (response.success) {
            console.log("✅ Password reset email sent:", response.data);

            
            setIsSubmitted(true);
        } else {
            console.error("❌ Error:", response.error);

            
            alert(`Error: ${response.error}`);
        }
    } catch (err) {
        console.error("❌ Unexpected error:", err);
        alert("Something went wrong. Please try again.");
    }
};

    const hostname = window.location.hostname;

    const matchesDomain = (host, domain) => host === domain || host.endsWith(`.${domain}`);

    const getTitle = () => {
        if (matchesDomain(hostname, "echocare.in")) return "echoCare";
        if (matchesDomain(hostname, "musicccare.com")) return "MUSICC Care";
        return "echoCare";
        // default
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                p: 2,
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            {/* Background animated circles */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
                    zIndex: 0,
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        width: 400,
                        height: 400,
                        borderRadius: '50%',
                        top: -100,
                        right: -100,
                        background: 'linear-gradient(135deg, #2ECC71, #1ABC9C)',
                        opacity: 0.1,
                        animation: 'float 20s infinite ease-in-out',
                        animationDelay: '0s',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        width: 300,
                        height: 300,
                        borderRadius: '50%',
                        bottom: -50,
                        left: -50,
                        background: 'linear-gradient(135deg, #1ABC9C, #9B59B6)',
                        opacity: 0.1,
                        animation: 'float 20s infinite ease-in-out',
                        animationDelay: '-5s',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        width: 200,
                        height: 200,
                        borderRadius: '50%',
                        top: '50%',
                        left: '10%',
                        background: 'linear-gradient(135deg, #9B59B6, #A855F7)',
                        opacity: 0.1,
                        animation: 'float 20s infinite ease-in-out',
                        animationDelay: '-10s',
                    }}
                />
            </Box>

            {/* Float keyframes */}
            <Box
                component="style"
                children={`
                    @keyframes float {
                        0%,100% { transform: translate(0,0) scale(1); }
                        25% { transform: translate(20px,-20px) scale(1.05); }
                        50% { transform: translate(-10px,20px) scale(0.95); }
                        75% { transform: translate(-20px,-10px) scale(1.02); }
                    }
                `}
            />
            <Box
                sx={{
                    position: 'absolute',
                    top: { xs: 18, sm: 18, md: 24 },
                    left: 24,
                    zIndex: 1000,
                    animation: 'slideDown 1.3s ease-out forwards',
                    '@keyframes slideDown': {
                        '0%': { transform: 'translateY(-50px)', opacity: 0 },
                        '100%': { transform: 'translateY(0)', opacity: 1 },
                    },
                }}
            >
                <Box sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 2,
                    // background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: '16px',
                    // padding: '12px 20px',
                    // border: '1px solid rgba(255, 255, 255, 0.3)',
                    // boxShadow: '0 8px 32px rgba(46, 204, 113, 0.15)'
                }}>
                    <img
                        src="/echobuddy-logo.svg"
                        alt="echoCare Logo"
                        style={{
                            height: '44px',
                            width: 'auto',
                            marginTop: "4px"
                        }}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            sx={{
                                fontSize: '1.4rem',
                                fontWeight: 700,
                                letterSpacing: 0.8,
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            {getTitle()}
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: '0.65rem',
                                fontWeight: 500,
                                letterSpacing: 0.6,
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            Heal. Hope. Harmony.
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Paper
                elevation={10}
                sx={{
                    width: '100%',
                    maxWidth: 500,
                    borderRadius: 4,
                    overflow: 'hidden',
                    position: 'relative',
                    zIndex: 1,
                    backdropFilter: 'blur(10px)',
                    backgroundColor: 'rgba(255, 255, 255, 0.85)',
                    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
                    border: '1px solid rgba(255, 255, 255, 0.18)'
                }}
            >
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{
                            fontWeight: 700, mb: { xs: 1, sm: 2 }, color: 'black', fontSize: { xs: 22, md: 32 },
                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                        }}
                    >
                        {isSubmitted ? 'Check Your Email' : 'Forgot Password'}
                    </Typography>

                    {!isSubmitted ? (
                        <>
                            <Typography color="text.secondary" sx={{ mb: { xs: 2, sm: 2, md: 4 }, maxWidth: '80%', mx: 'auto', fontSize: { xs: 13, sm: 15, md: 16 } }}>
                                Enter your email address and we’ll send you a link to reset your password.
                            </Typography>

                            <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    label="Email Address"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onFocus={() => {
                                        if (!email) {
                                            const emailParam = searchParams.get('email');
                                            if (emailParam) {
                                                setEmail(decodeURIComponent(emailParam));
                                            }
                                        }
                                    }}
                                    required
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <MailOutline color="primary" />
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{
                                        mb: 3,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2,
                                            '& fieldset': {
                                                borderColor: 'rgba(0, 0, 0, 0.1)',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'primary.main',
                                            },
                                        },
                                    }}
                                />

                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    size="large"
                                    sx={{
                                        py: 1.5,
                                        borderRadius: 2,
                                        textTransform: 'none',
                                        fontSize: { xs: 14, sm: 16, md: 16 },
                                        fontWeight: 600,
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                        boxShadow: '0 4px 20px rgba(34, 197, 94, 0.35)',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 6px 24px rgba(34, 197, 94, 0.5)',
                                        },
                                        transition: 'all 0.3s ease',
                                    }}
                                >
                                    Send Reset Link
                                </Button>

                                <Box sx={{ textAlign: 'center', mt: 2 }}>
                                    <Typography variant="body2" color="text.secondary">
                                        <Link
                                            to="/"
                                            style={{
                                                color: '#22c55e',
                                                textDecoration: 'none',
                                                fontWeight: 500,
                                            }}
                                        >
                                            Back to Sign In
                                        </Link>
                                    </Typography>
                                </Box>
                            </Box>
                        </>
                    ) : (
                        <Box sx={{ py: 2 }}>
                            <Box
                                sx={{
                                    width: 100,
                                    height: 100,
                                    borderRadius: '50%',
                                    background: 'rgba(102, 187, 106, 0.1)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 20px',
                                    color: '#4caf50',
                                    fontSize: '3rem',
                                    lineHeight: 1
                                }}
                            >
                                ✓
                            </Box>
                            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: '90%', mx: 'auto' }}>
                                We’ve sent a password reset link to <strong>{email}</strong>. Please check your inbox and follow the instructions to reset your password.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Paper >
        </Box >
    );
}

export default ConsultForgotPassword;
